module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABRUlEQVRIS+2VPy9DURjGf+/Ve8smFhEzEoMYmCz9BEaCvadCJJ0NWAwkEn+ivSIxmXwDC10kJBITi01i8AGIe6uvtE0J7u1t6TX1TCc55/09b57z5D1CjEtiZNM4PPeSYr7rvJlmGoO7/jJoH8ZZbB38UHsoejuIzCGSIm0XWgPPPU/QkdhHGQFuKL1lkc4nMnLbqECwLa5ngHwoRPUBkQ2Ms1dPKAx+BYxHdygnGHsq7F74g7r+Fmi2WqinYF1Ut6UhRGY+gXqPSQ4ECdRPS/51GrG2QXsp6jALybsKpBxLK5EFnawKskvGWfouEB3FAx1Ei5vAJcZe/wAcaTeefwaMAtcYZ6x5eK3C9Vcw9toXgOsdA7OIPJK2+38PDzK1LIiuVo6M88OFaFvqRaYND3Snbcv/21IeA7UV8Ev9LecRYzNW+DskC28YWrU24wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/maptool/draw/zjt.png
// module id = Nhuw
// module chunks = 35